/** @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/core';

import { Box, CircularProgress, Grid } from '@material-ui/core';
import PageContainer from 'components/PageContainer';

import { useMarkdownTranslate } from 'hooks/useTranslate/useTranslate';
import styles from './styles';

interface LoadingViewProps {
  headerTitle: string;
}

const LoadingPage: React.FC<LoadingViewProps> = props => {
  const tMd = useMarkdownTranslate();
  const { headerTitle } = props;
  return (
    <PageContainer>
      <Grid container alignItems="center" justify="center">
        <Grid item>
          <Box mb={3}>
            <h1 css={styles.titleText}>{tMd(headerTitle)}</h1>
          </Box>
          <Box my={5} textAlign="center">
            <CircularProgress aria-label="progress" size={24} />
          </Box>
        </Grid>
      </Grid>
    </PageContainer>
  );
};

export default LoadingPage;
